import { gql } from 'graphql-request'

export const BUY_BOOK_CHAPTERS = gql`
  mutation BuyBookChapters($buyBookChaptersInput: BuyBookChaptersInput!) {
    buyBookChapters(buyBookChaptersInput: $buyBookChaptersInput) {
      transactionId
    }
  }
`
